export default __webpack_public_path__ + "static/media/front.08394e04.jpg";